// extracted by mini-css-extract-plugin
module.exports = {"packDownloadPage":"packDownloadPage--_535l","down_title":"down_title--1TIpt","down_desc":"down_desc--2DOYd","wxCode":"wxCode--3QYIo","wxDec":"wxDec--3p4Jg"};